import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Container, Row, Col, CardGroup, Card, CardBody } from "reactstrap";
import userService from "../../services/userService";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { showErrorToaster } from "../../State/actions/toaster";
import MPSBarLoader from "../../components/MPSBarLoader";
import { parseURLQueryParams } from "../../utils/utils";
import Text from "../../components/Text";
import I18nProvider from "../../services/I18nProvider";
import Messages from "../../Shared/Messages";
import RegionSelector from "../RegionSelector";
import "./ForgotPasswordView.scss";
const intl = I18nProvider.getIntlProvider();

class ForgotPasswordView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    document.title = "Forgot Password — myPatientSpace";
  }

  sendForgotPasswordReq = (phone, contactLabel) => {
    this.setState({ loading: true });
    userService
      .processForgotPasswordRequest(phone)
      .then((response) => {
        this.setState({ loading: false, status: "succeeded", contactLabel });
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.props.showErrorToaster(
          error,
          intl.formatMessage(Messages.password_reset_failed),
          7
        );
      });
  };

  render() {
    let { status, loading, contactLabel } = this.state;
    return (
      <main id="main-layout" className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              {loading && <MPSBarLoader />}
              <CardGroup>
                <Card className="p-4">
                  <div className="d-flex justify-content-center mb-4">
                    <img src="/img/logo-symbol.png" height={42} alt="myPatientSpace logo" />
                  </div>
                  <CardBody>
                    {!status && (
                      <ForgotPasswordForm
                        sendRequest={this.sendForgotPasswordReq}
                        linkType={this.props.linkType}
                      />
                    )}
                    {status === "succeeded" && (
                      <div className="text-center">
                        <p>
                          <Text
                            content={Messages.forgot_password_confirmation}
                            data={{ contact: <strong>{contactLabel}</strong> }}
                          />
                        </p>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </CardGroup>

              <div className="my-4 d-flex flex-column justify-content-center align-items-center fp-region-row">
                {!status && (
                  <div>
                    <RegionSelector
                      className="drop-up"
                      style={{
                        backgroundColor: "#f7f7f7",
                        border: 0,
                        width: 65,
                        height: 30,
                      }}
                    />
                  </div>
                )}
                <Link to="/login" className="fp-return-link">
                  <Text content={Messages.return_to_login} />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </main>
    );
  }
}

const actions = {
  showErrorToaster,
};

const data = (state, ownProps) => {
  let params = null;
  if (ownProps.location && ownProps.location.search) {
    params = parseURLQueryParams(ownProps.location.search);
  }

  return {
    linkType: params ? params.cp : null,
  };
};

export default connect(data, actions)(ForgotPasswordView);
